import {lazy} from 'react'
import {PublicRoute} from 'components/HOCs'
import {componentLoader} from 'utils'
import {DefaultLayout, EmptyLayout} from 'components'
import {CASBRoutesEnum} from 'interfaces'

const LoginPage = lazy(() =>
  componentLoader(
    () => import(/* webpackChunkName: "Login" */ 'features/User/Login'),
  ),
)
const LoginFailurePage = lazy(() =>
  componentLoader(
    () =>
      import(
        /* webpackChunkName: "Login_Failure" */ 'features/User/Login/failure'
      ),
  ),
)

const CallbackInfoPage = lazy(() =>
  componentLoader(
    () =>
      import(/* webpackChunkName: "CallbackInfo" */ 'features/CallbackInfo'),
  ),
)

const SettingsPage = lazy(() =>
  componentLoader(
    () =>
      import(
        /* webpackChunkName: "User_Import_Guest" */ 'features/Admin/Settings'
      ),
  ),
)

const ImportCallbackPage = lazy(() =>
  componentLoader(
    () =>
      import(
        /* webpackChunkName: "ImportCallbackInfo" */ 'features/ImportCallbackInfo'
      ),
  ),
)

const VerifyAdminImport = lazy(() =>
  componentLoader(
    () =>
      import(
        /* webpackChunkName: "VerifyAdminImport" */ 'features/Settings/General/VerifyAdminImport'
      ),
  ),
)

const MultiAccountsPage = lazy(() =>
  componentLoader(
    () =>
      import(
        /* webpackChunkName: "MultiAccounts" */ 'features/CallbackInfo/MultiAccounts'
      ),
  ),
)

const OIDCWelcome = lazy(() =>
  componentLoader(
    () =>
      import(/* webpackChunkName: "OIDCWelcome" */ 'features/User/OIDCWelcome'),
  ),
)

const CASBAccessPage = lazy(() =>
  componentLoader(() => import('features/CASB/Access')),
)

const PublicRoutesList = [
  <PublicRoute
    exact
    path="/"
    key="/"
    component={LoginPage}
    layoutProps={{
      bgColor: 'bg-dope-black',
    }}
  />,
  <PublicRoute
    exact
    path="/tenants"
    key="/tenants"
    component={MultiAccountsPage}
    layoutProps={{
      bgColor: 'bg-dope-black',
    }}
  />,
  <PublicRoute
    exact
    path="/login-failure"
    key="/login-failure"
    component={LoginFailurePage}
    layoutProps={{
      bgColor: 'bg-dope-black',
    }}
  />,

  <PublicRoute
    exact
    path="/callback"
    key="/callback"
    component={CallbackInfoPage}
    layoutProps={{
      bgColor: 'bg-dope-black',
    }}
  />,

  <PublicRoute
    exact
    path={['/settings', '/settings/grant-access']}
    key="/settings"
    component={SettingsPage}
    layout={DefaultLayout}
  />,
  <PublicRoute
    exact
    path="/import-callback"
    key="/import-callback"
    component={ImportCallbackPage}
    layout={DefaultLayout}
  />,
  <PublicRoute
    exact
    path="/verify-admin"
    key="/verify-admin"
    component={VerifyAdminImport}
    layout={DefaultLayout}
    layoutProps={{
      bgColor: 'bg-dope-black',
    }}
  />,
  <PublicRoute
    exact
    path="/oidc-welcome"
    key="/oidc-welcome"
    component={OIDCWelcome}
    layoutProps={{
      bgColor: 'bg-dope-black',
    }}
  />,
  <PublicRoute
    exact
    path={[
      CASBRoutesEnum.GRANT_ACCESS,
      CASBRoutesEnum.ACCESS_GRANTED,
      CASBRoutesEnum.ACCESS_DENIED,
      CASBRoutesEnum.SYNC_FAILURE,
    ]}
    key={CASBRoutesEnum.GRANT_ACCESS}
    component={CASBAccessPage}
    layout={EmptyLayout}
  />,
]

export const PublicRoutes = (): JSX.Element[] => {
  return [...PublicRoutesList]
}
